// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UoT_","content":"styles_content__3clAZ"};